<template>
  <div class="product-template">
    <div class="page-header">
      <div class="container">
        <h1 class="fade-in-up">{{ title }}</h1>
        <p class="description fade-in-up">{{ description }}</p>
        <div class="header-actions fade-in-up" v-if="showActions">
          <a href="#contact" class="btn btn-primary">
            联系我们
            <el-icon><ArrowRight /></el-icon>
          </a>
          <a href="#learn-more" class="btn btn-outline">
            了解更多
          </a>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'

defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  showActions: {
    type: Boolean,
    default: true
  }
})

const observeElements = () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible')
      }
    })
  }, {
    threshold: 0.1
  })

  document.querySelectorAll('.fade-in-up').forEach(el => {
    observer.observe(el)
  })

  return observer
}

let observer
onMounted(() => {
  observer = observeElements()
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})
</script>

<style lang="scss" scoped>
.product-template {
  min-height: 100vh;

  .header-actions {
    margin-top: 30px;
    display: flex;
    gap: 16px;
    justify-content: center;
  }
}
</style> 